(ns quuppa.peweb.tags.subs
  (:require [re-frame.core :as rf]))


(rf/reg-sub ::tag-location
  (fn [[_ qpe-identity _tag]]
    (rf/subscribe [:qpe/data qpe-identity :tags :location]))
  (fn [tags-locations [_ _ tag]]
    (get tags-locations (:resolved-id tag))))


(rf/reg-sub ::per-cs
  (fn [[_ qpe-identity]]
    (rf/subscribe [:qpe/data qpe-identity :tags :location]))
  (fn [locations [_ _]]
    (reduce-kv (fn [acc k {:keys [cs-id] :as l}]
                 (assoc-in acc [cs-id k] l))
               {}
               locations)))
